import { FinanceRate } from '@kanda-libs/ks-frontend-services';

import { PERCENTAGES } from './constants';

export const calculateRateDepositLimits = (
  total: number,
  rate: FinanceRate,
): number[] => {
  const {
    min_deposit_pct: minDepPct = 0,
    max_deposit_pct: maxDepPct = 0,
    min_deposit_value: minDepVal = 0,
    max_deposit_value: maxDepVal = 0,
    min_job_value: minJobVal = 0,
    max_job_value: maxJobVal = 0,
  } = rate;

  const minPossibleDeposit = Math.max(
    total * (minDepPct / 10000),
    minDepVal,
    total - maxJobVal,
  );

  const maxPossibleDeposit = Math.min(
    total * (maxDepPct / 10000),
    maxDepVal || Infinity,
    total - minJobVal,
  );

  return [minPossibleDeposit, maxPossibleDeposit];
};

export interface DepositPercentage {
  percentage: string;
  value: number;
}

export const calculatePercentage = (
  percentage: number,
  total: number,
): number => {
  if (percentage === 0) return 0;
  return Math.floor((percentage * total) / 100);
};

export const determineValidDeposits = (
  total: number,
  rates: FinanceRate[],
): DepositPercentage[] => {
  const depositAmounts = PERCENTAGES.map((pct) => ({
    percentage: `${pct}%`,
    value: calculatePercentage(pct, total),
  }));

  const limits = rates.reduce(
    (final: number[], rate) => {
      const rateLimits = calculateRateDepositLimits(total, rate);
      return [
        Math.min(final[0], rateLimits[0]),
        Math.max(final[1], rateLimits[1]),
      ];
    },
    [Infinity, -Infinity],
  );

  return depositAmounts.filter(
    (v) => v.value >= limits[0] && v.value <= limits[1],
  );
};
